import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { StudioState } from '@/store/types/studio.state';
import ColorScaleService from '@/services/ColorScale.service';

export const getters: GetterTree<StudioState, RootState> = {
    getSelectedColorsAdded(state): string {
        const notes = state.selectedColors;
        let R = 0;
        let G = 0;
        let B = 0;
        for (let i = 0; i < notes.length; i++) {
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(notes[i]);
            if (result != null) {
                R += parseInt(result[1], 16);
                G += parseInt(result[2], 16);
                B += parseInt(result[3], 16);
            }
        }
        R /= notes.length;
        G /= notes.length;
        B /= notes.length;

        let hexR = Math.round(R).toString(16);
        let hexG = Math.round(G).toString(16);
        let hexB = Math.round(B).toString(16);
        hexR = hexR.length == 1 ? "0" + hexR : hexR;
        hexG = hexG.length == 1 ? "0" + hexG : hexG;
        hexB = hexB.length == 1 ? "0" + hexB : hexB;

        return "#" + hexR + hexG + hexB;
    },
    getSelectedColorRGBBase1(state): string {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(state.selectedColor);
        if (result != null) {
            const r = parseInt(result[1], 16) / 255;
            const g = parseInt(result[2], 16) / 255;
            const b = parseInt(result[3], 16) / 255;
            return `${r} , ${g} , ${b}`;
        } else {
            return 'null';
        }
    }
};